import { clearArcadeArcade } from './sections/arcade/actions';

export const clearArcade = () => (dispatch) => {
    dispatch(clearArcadeArcade());
};
